// API
const API_BASE = 'https://api.gemsmantra.com/api/certificates';

// DOM
const $ = {
    input: document.getElementById('checkcart_certInput'),
    button: document.getElementById('checkcart_verifyBtn'),
    card: document.getElementById('checkcart_resultCard'),
    idle: document.getElementById('checkcart_stateIdle'),
    loading: document.getElementById('checkcart_stateLoading'),
    notFound: document.getElementById('checkcart_stateNotFound'),
    apiError: document.getElementById('checkcart_stateApiErr'),
    error: document.getElementById('checkcart_errMsg'),
    image: document.getElementById('checkcart_rImage'),
    placeholder: document.getElementById('checkcart_rImgPlaceholder'),
    zoom: document.getElementById('checkcart_zoomHint'),
    title: document.getElementById('checkcart_rGemName'),
    report: document.getElementById('checkcart_rReportLabel'),
    table: document.getElementById('checkcart_certTableBody'),
    lightbox: document.getElementById('checkcart_lightboxOverlay'),
    lightboxImg: document.getElementById('checkcart_lightboxImg'),
    lightboxCaption: document.getElementById('checkcart_lightboxCaption'),
    lightboxClose: document.getElementById('checkcart_lightboxClose')
};

// States
const STATES = [$.idle, $.loading, $.notFound, $.apiError, $.card];

// Show state
const showState = active => {
    STATES.forEach(el => { if (el) el.classList.remove('visible'); });
    active.classList.add('visible');
};

// Format label
const formatLabel = text =>
    text.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase());

// Check if a value is present (not blank / null / "null")
const hasValue = value =>
    value !== null &&
    value !== undefined &&
    String(value).trim() !== '' &&
    String(value).trim().toLowerCase() !== 'null';

// Return display value or fallback dash
const getValue = value => hasValue(value) ? value : '—';

// Image fallback
const imageFallback = () => {
    $.image.style.display = 'none';
    $.placeholder.style.display = 'flex';
    $.zoom.style.display = 'none';
};

// Fields that are handled elsewhere and should NOT appear as table rows
const TABLE_SKIP_FIELDS = new Set([
    's3_url',
    'created_at',
    'updated_at',
    'species',     // shown in the card title heading
    'variety',     // shown in the card title heading
]);

const TABLE_FIELDS = [
{ key: 'product_name', label: 'Product Name' },
{ key: 'report_number', label: 'Report Number' },
{ key: 'date_of_issue', label: 'Date Of Issue' },
{ key: 'species', label: 'Species' },
{ key: 'variety', label: 'Variety' },
{ key: 'weight', label: 'Weight (ct)' },
{ key: 'ratti', label: 'Ratti (rt)' },
{ key: 'color', label: 'Color' },
{ key: 'shape', label: 'Shape' },
{ key: 'cutting_style', label: 'Cutting Style' },
{ key: 'refractive_index', label: 'Refractive Index (R.I)' },
{ key: 'birefringence', label: 'Birefringence' },
{ key: 'optic_character', label: 'Optic Character' },
{ key: 'specific_gravity', label: 'Specific Gravity (S.G)' },
{ key: 'hardness', label: 'Hardness' },
{ key: 'origin', label: 'Origin' },
{ key: 'comments', label: 'Comments' },
{ key: 'artificial_faces', label: 'Artificial Faces' },
{ key: 'test_carried_out', label: 'Test Carried Out' }
];


// true  = always show every column (blank ones show "—")
// false = hide a column when it has no value
const SHOW_EMPTY_ROWS = false;

const buildTable = (data) => {
    $.table.innerHTML = '';

    const addRow = (label, value) => {
        const present = hasValue(value);
        if (!present && !SHOW_EMPTY_ROWS) return;   // skip blanks when configured

        const row = document.createElement('tr');
        const th  = document.createElement('th');
        th.textContent = label;

        const td = document.createElement('td');
        td.textContent = present ? value : '—';

        row.appendChild(th);
        row.appendChild(td);
        $.table.appendChild(row);
    };

    // Render every field in the exact order defined in TABLE_FIELDS
    TABLE_FIELDS.forEach(field => addRow(field.label, data[field.key]));
};


// Populate card
const populateCard = (data, certId) => {
    //  Image 
    if (hasValue(data.s3_url)) {
        $.image.src = data.s3_url;
        $.image.style.display = 'block';
        $.placeholder.style.display = 'none';
        $.zoom.style.display = 'flex';
    } else {
        imageFallback();
    }
    $.image.onerror = imageFallback;

    //  Title: Species - Variety, fallback to product_name or certId 
    const species = hasValue(data.species) ? data.species : '';
    const variety = hasValue(data.variety) ? data.variety : '';

    let titleText = '';

    if (species && variety) {
        titleText = `${species} - ${variety}`;
    } else if (species) {
        titleText = species;
    } else if (variety) {
        titleText = variety;
    } else {
        titleText = data.report_number || certId || 'Gemstone Report';
    }

    $.title.textContent = titleText;

    //  Report number 
    $.report.textContent = `REPORT NO: ${
        data.report_number || data.product_serial_number || certId || '—'
    }`;

    //  Table 
    buildTable(data);
};

// Button loading state
const buttonLoading = status => {
    $.button.disabled = status;
    $.button.innerHTML = status ? 'Verifying...' : 'Verify';
};

// Fetch certificate from API 
const fetchCertificate = async certId => {

    const url = `${API_BASE}/${encodeURIComponent(certId)}`;

    console.log('Request URL:', url);

    const response = await fetch(url, {
        method: 'GET',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json'
        }
    });

    console.log('Status:', response.status);
    console.log('Status Text:', response.statusText);

    // Response body sirf ek baar read karo
    const data = await response.json();

    console.log('Response:', data);

    // Certificate nahi mila
    if (response.status === 404) {
        return {
            success: false,
            data: null
        };
    }

    // Kisi aur server error ke liye
    if (!response.ok) {
        throw new Error(data.message || `HTTP ${response.status}`);
    }

    return data;
};

// Main lookup
const lookupCertificate = async () => {
    const certId = $.input.value.trim().toUpperCase();
    if (!certId) return;

    buttonLoading(true);
    showState($.loading);

    try {
        const result = await fetchCertificate(certId);
     
        if (!result.success || !result.data) {
            showState($.notFound);
            return;
        }
        populateCard(result.data, certId);
        showState($.card);
    } catch (error) {
        $.error.textContent = error.message || 'Server Error';
        showState($.apiError);
    } finally {
        buttonLoading(false);
    }
};

// Lightbox
const openLightbox = () => {
    if (!$.image.src) return;
    $.lightboxImg.src = $.image.src;
    $.lightboxCaption.textContent = $.title.textContent;
    $.lightbox.classList.add('open');
    document.body.style.overflow = 'hidden';
};

const closeLightbox = () => {
    $.lightbox.classList.remove('open');
    document.body.style.overflow = '';
};

// Events
$.button.addEventListener('click', lookupCertificate);
$.input.addEventListener('keydown', e => { if (e.key === 'Enter') lookupCertificate(); });
$.image.addEventListener('click', openLightbox);
$.zoom.addEventListener('click', openLightbox);
$.lightboxClose.addEventListener('click', closeLightbox);
$.lightbox.addEventListener('click', e => { if (e.target === $.lightbox) closeLightbox(); });
document.addEventListener('keydown', e => { if (e.key === 'Escape') closeLightbox(); });

// Default
showState($.idle);